import React, { useState, useEffect } from 'react';
import { 
  TextField, Button, Checkbox, Container, FormControlLabel, 
  InputLabel, Select, MenuItem, Typography, Grid, Box,
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, createTheme, useMediaQuery
} from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { useTranslation } from 'react-i18next';
import { addArticle, getUnitsOfMeasure, getIngredients, addRecipe } from '../../api/axios';
import Articles from '../List/Articles';

const NewArticle = () => {
    const { t } = useTranslation('global');

    const [name, setName] = useState('');
    const [unitOfMeasure, setUnitOfMeasure] = useState('');
    const [numPortion, setNumPortion] = useState(0);
    const [unitPrice, setUnitPrice] = useState(0);
    const [active, setActive] = useState(false);
    const [button, setButton] = useState(0);

    const [unitsOfMeasure, setUnitsOfMeasure] = useState([]);
    const [ingredients, setIngredients] = useState([]);
    const [selectedIngredients, setSelectedIngredients] = useState([]);
    const [ingredientNorms, setIngredientNorms] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');

    const [refreshKey, setRefreshKey] = useState(0);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [unitsRes, ingredientsRes] = await Promise.all([
                    getUnitsOfMeasure(),
                    getIngredients()
                ]);
                setUnitsOfMeasure(unitsRes);
                setIngredients(ingredientsRes);
            } catch (error) {
                console.error("Failed to fetch data:", error);
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if(!name) {
            setErrMsg(t("newOrganizationUnit.nameRequired"));
            return;
        }

        const newArticle = {
            name,
            unit_of_measure_id: parseInt(unitOfMeasure),
            num_portion: parseInt(numPortion),
            unit_price: parseFloat(unitPrice),
            active: active ? 1 : 0,
            button: parseInt(button)
        };
        console.log(newArticle);

        try {
            // First add the article
            const articleResponse = await addArticle(newArticle);
            console.log(articleResponse);
            if(!articleResponse.success) {
                setErrMsg(t("newTicket.somethingWentWrong"));
                setTimeout(() => setErrMsg(''), 3000);
                return;
            }

            // Then add recipes for each selected ingredient
            const recipePromises = selectedIngredients.map(ingredientId => {
                const ingredient = ingredients.find(i => i.id === ingredientId);
                console.log(articleResponse.id + " " + ingredientId + " " + ingredientNorms[ingredientId]);
                return addRecipe({
                    article_id: articleResponse.id,
                    ingredient_id: ingredientId,
                    norm_per_portion: ingredientNorms[ingredientId] || 0
                });
            });

            await Promise.all(recipePromises);

            setSucc(t("newTicket.successfullyAdded"));
            setName('');
            setUnitOfMeasure('');
            setNumPortion(0);
            setUnitPrice(0);
            setActive(false);
            setButton(0);
            setSelectedIngredients([]);
            setIngredientNorms({});
            
            setTimeout(() => setSucc(''), 3000);
            setRefreshKey(prev => prev + 1);

        } catch (error) {
            setErrMsg(t("newTicket.failedToAddTicket"));
        }
    };

    const theme = createTheme({
        breakpoints: {
            values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xxl: 1650
            },
        },
    })
    const isSmall = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Container maxWidth="lg" className="container-employee" sx={{ p: 3, flexShrink: 0, mt: 4 }}>
            <Typography variant="h4" sx={{ mb:4 }}>{t("article.newArticle")}</Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{width: "90%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                {isSmall ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.name")}
                                fullWidth
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Select
                                fullWidth
                                value={unitOfMeasure}
                                onChange={(e) => setUnitOfMeasure(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>
                                    {t("article.unitOfMeasure")}
                                </MenuItem>
                                {unitsOfMeasure.map((unit) => (
                                    <MenuItem key={unit.id} value={unit.id}>
                                        {unit.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.unitPrice")}
                                fullWidth
                                value={unitPrice}
                                onChange={(e) => setUnitPrice(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.numPortion")}
                                fullWidth
                                value={numPortion}
                                onChange={(e) => setNumPortion(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.button")}
                                fullWidth
                                value={button}
                                onChange={(e) => setButton(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={active}
                                        onChange={(e) => setActive(e.target.checked)}
                                    />
                                }
                                label={t("article.active")}
                            />
                        </Grid>
                        {/* Article details */}
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.name")}
                                fullWidth
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Select
                                fullWidth
                                value={unitOfMeasure}
                                onChange={(e) => setUnitOfMeasure(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>
                                    {t("article.unitOfMeasure")}
                                </MenuItem>
                                {unitsOfMeasure.map((unit) => (
                                    <MenuItem key={unit.id} value={unit.id}>
                                        {unit.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.unitPrice")}
                                fullWidth
                                value={unitPrice}
                                onChange={(e) => setUnitPrice(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.numPortion")}
                                fullWidth
                                value={numPortion}
                                onChange={(e) => setNumPortion(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t("article.button")}
                                fullWidth
                                value={button}
                                onChange={(e) => setButton(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={active}
                                        onChange={(e) => setActive(e.target.checked)}
                                    />
                                }
                                label={t("article.active")}
                            />
                        </Grid>

                        {/* Ingredients table */}
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                                {t("article.ingredients")}
                            </Typography>
                            <TextField
                                label={t("article.searchIngredients")}
                                fullWidth
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t("article.select")}</TableCell>
                                            <TableCell>{t("article.ingredient")}</TableCell>
                                            <TableCell>{t("article.normPerPortion")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ingredients
                                            .filter(ingredient => 
                                                ingredient.name.toLowerCase().includes(searchTerm.toLowerCase())
                                            )
                                            .map((ingredient) => (
                                            <TableRow key={ingredient.id}>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={selectedIngredients.includes(ingredient.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedIngredients([...selectedIngredients, ingredient.id]);
                                                            } else {
                                                                setSelectedIngredients(selectedIngredients.filter(id => id !== ingredient.id));
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>{ingredient.name}</TableCell>
                                                <TableCell>
                                                    <TextField
                                                        size="small"
                                                        type="number"
                                                        value={ingredientNorms[ingredient.id] || ''}
                                                        onChange={(e) => setIngredientNorms({
                                                            ...ingredientNorms,
                                                            [ingredient.id]: parseFloat(e.target.value) || 0
                                                        })}
                                                        disabled={!selectedIngredients.includes(ingredient.id)}
                                                        InputProps={{
                                                            inputProps: { min: 0, step: 0.01 }
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" type="submit" sx={{ width: '50%' }}>
                                {t("newTicket.add")}
                            </Button>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={2}>
                        {/* Left column - Article details */}
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("article.name")}
                                        fullWidth
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Select
                                        fullWidth
                                        value={unitOfMeasure}
                                        onChange={(e) => setUnitOfMeasure(e.target.value)}
                                        displayEmpty
                                    >
                                        <MenuItem value="" disabled>
                                            {t("article.unitOfMeasure")}
                                        </MenuItem>
                                        {unitsOfMeasure.map((unit) => (
                                            <MenuItem key={unit.id} value={unit.id}>
                                                {unit.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("article.unitPrice")}
                                        fullWidth
                                        value={unitPrice}
                                        onChange={(e) => setUnitPrice(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("article.numPortion")}
                                        fullWidth
                                        value={numPortion}
                                        onChange={(e) => setNumPortion(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("article.button")}
                                        fullWidth
                                        value={button}
                                        onChange={(e) => setButton(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={active}
                                                onChange={(e) => setActive(e.target.checked)}
                                            />
                                        }
                                        label={t("article.active")}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Right column - Ingredients table */}
                        <Grid item xs={6}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                {t("article.ingredients")}
                            </Typography>
                            <TextField
                                label={t("article.searchIngredients")}
                                fullWidth
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t("article.select")}</TableCell>
                                            <TableCell>{t("article.ingredient")}</TableCell>
                                            <TableCell>{t("article.normPerPortion")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ingredients
                                            .filter(ingredient => 
                                                ingredient.name.toLowerCase().includes(searchTerm.toLowerCase())
                                            )
                                            .map((ingredient) => (
                                            <TableRow key={ingredient.id}>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={selectedIngredients.includes(ingredient.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedIngredients([...selectedIngredients, ingredient.id]);
                                                            } else {
                                                                setSelectedIngredients(selectedIngredients.filter(id => id !== ingredient.id));
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>{ingredient.name}</TableCell>
                                                <TableCell>
                                                    <TextField
                                                        size="small"
                                                        type="number"
                                                        value={ingredientNorms[ingredient.id] || ''}
                                                        onChange={(e) => setIngredientNorms({
                                                            ...ingredientNorms,
                                                            [ingredient.id]: parseFloat(e.target.value) || 0
                                                        })}
                                                        disabled={!selectedIngredients.includes(ingredient.id)}
                                                        InputProps={{
                                                            inputProps: { min: 0, step: 0.01 }
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {/* Submit button spanning both columns */}
                            <Grid item xs={12} sx={{display: "flex", justifyContent: "flex-end", mt: 3}}>
                                <Button variant="contained" type="submit" sx={{ width: '50%' }}>
                                    {t("newTicket.add")}
                                </Button>
                            </Grid>
                        </Grid>

                        
                    </Grid>
                )}
            </Box>

            {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
            {succ && <Success message={succ} onClose={() => setSucc('')} />}

            <Articles key={refreshKey}/>
        </Container>
    );
};

export default NewArticle;
